import { render } from "./CompanyView.vue?vue&type=template&id=d1f20ac8&scoped=true"
import script from "./CompanyView.vue?vue&type=script&lang=js"
export * from "./CompanyView.vue?vue&type=script&lang=js"

import "./CompanyView.vue?vue&type=style&index=0&id=d1f20ac8&scoped=true&lang=css"

import exportComponent from "/Users/felix/dev/projects/protfolio/schillerando-demo/schillerando-demo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1f20ac8"]])

export default __exports__